import { useCallback } from 'react';
import { useAttachmentsDownloadStore } from '../attachments-download-store-provider';

export function useAttachmentsDownloadStatus(attachmentId: number) {
    const downloadStore = useAttachmentsDownloadStore();

    const download = downloadStore.getDownload(attachmentId);

    const setProgress = useCallback(
        (fileName: string, progress: number) =>
            downloadStore.setDownloadProgress(attachmentId, fileName, progress),
        [downloadStore, attachmentId]
    );

    const clearDownload = useCallback(() => downloadStore.removeDownload(attachmentId), [
        downloadStore,
        attachmentId,
    ]);

    return {
        download,
        isDownloading: download?.status === 'downloading',
        progress: download?.progress ?? 0,
        setProgress,
        clearDownload,
    };
}
